import { Enemy, Gun, KeyVar } from "../types"

export const gunCharacteristics: {
    [key in keyof typeof Gun]: {
        interval: number
        shot: number
        distance: number
    }
} = {
    gun: {
        interval: 120,
        shot: 200,
        distance: 30,
    },
    fire: {
        interval: 100,
        shot: 40,
        distance: 7,
    },
    freeze: {
        interval: 100,
        shot: 2,
        distance: 7,
    },
}

export const gunCharacteristicsFC: {
    [key in keyof typeof Gun]: {
        interval: number
        shot: number
        distance: number
        freezing: number
        hitAllInZone: boolean
    }
} = {
    gun: {
        interval: 120,
        shot: 200,
        distance: 30,
        freezing: 0,
        hitAllInZone: false
    },
    fire: {
        interval: 100,
        shot: 40,
        distance: 7,
        freezing: 0,
        hitAllInZone: true
    },
    freeze: {
        interval: 100,
        shot: 2,
        distance: 7,
        freezing: 0,
        hitAllInZone: true
    },
}

export const calcEnemy: {
    [key in keyof typeof KeyVar]: {
        numbersList: (item: Enemy) => number
        findEnemy: (list: number[]) => (item: Enemy) => boolean
    }
} = {
    w: {
        numbersList: (item: Enemy) => item.posX,
        findEnemy: (list: number[]) => (item: Enemy) => item.posX === Math.max(...list)
    },
    s: {
        numbersList: (item: Enemy) => item.posX,
        findEnemy: (list: number[]) => (item: Enemy) => item.posX === Math.min(...list)
    },
    a: {
        numbersList: (item: Enemy) => item.posY,
        findEnemy: (list: number[]) => (item: Enemy) => item.posY === Math.max(...list)
    },
    d: {
        numbersList: (item: Enemy) => item.posY,
        findEnemy: (list: number[]) => (item: Enemy) => item.posY === Math.min(...list)
    },
}

export const calcZoneList: {
    [key in keyof typeof KeyVar]: (x: number, y: number) => (el: any, index: number) => [number, number]
} = {
    w: (x: number, y: number) => (el, index) => [x - (index + 1), y],
    a: (x: number, y: number) => (el, index) => [x, y - (index + 1)],
    s: (x: number, y: number) => (el, index) => [x + (index + 1), y],
    d: (x: number, y: number) => (el, index) => [x, y + (index + 1)],
}

export const moveList: {
    [key in KeyVar]: {
        x: number
        y: number
    }
} = {
    w: {
        x: -1,
        y: 0,
    },
    s: {
        x: 1,
        y: 0,
    },
    a: {
        x: 0,
        y: -1
    },
    d: {
        x: 0,
        y: 1
    }
}